module.exports = __webpack_public_path__ + "img/detail4.17815626.png";